import {
  Box,
  Button,
  ButtonGroup,
  Grid,
  List,
  ListItem,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import stylesGap from "../../styles/pages/notification.module.scss";
import styles from "../../styles/pages/user/memberpartner/partner-notification.module.scss";
import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import DoubleCheckIcon from "../../ui/Icons/DoubleCheckIcon";
import BookmarkIcon from "../../ui/Icons/BookmarkIcon";
import RemoveIcon from "../../ui/Icons/RemoveIcon";
import NotificationNoItemIcon from "../../ui/Icons/NotificationNoItemIcon";
import Notiuserbatch from "../../public/assets/images/noti-userbatch.svg";
import Notiattach from "../../public/assets/images/noti-attach.svg";
import Notibuyer from "../../public/assets/images/noti-buyer.svg";
import Noticheck from "../../public/assets/images/noti-check.svg";
import Noticopy from "../../public/assets/images/noti-copy.svg";
import Noticopywritter from "../../public/assets/images/noti-copywritter.svg";
import Noticross from "../../public/assets/images/noti-cross.svg";
import Notidoubleuser from "../../public/assets/images/noti-doubleuser.svg";
import Notieditor from "../../public/assets/images/noti-editor.svg";
import Notiglobe from "../../public/assets/images/noti-globe.svg";
import Notimoreuser from "../../public/assets/images/noti-moreuser.svg";
import Notiusernote from "../../public/assets/images/noti-usernote.svg";
import Notiusersetting from "../../public/assets/images/noti-usersetting.svg";
import Notivideo from "../../public/assets/images/noti-video.svg";
import Notivideocut from "../../public/assets/images/noti-videocut.svg";
import Notitipalti from "../../public/assets/images/noti-tipalti.png";
import msgQc from "../../public/assets/images/msg-qc.svg";
import msgQcPlus from "../../public/assets/images/msg-qc-plus.svg";
import msgResolve from "../../public/assets/images/msg-resolve.svg";
import msgReopen from "../../public/assets/images/msg-reopen.svg";
import msgEditor from "../../public/assets/images/msg-editor.svg";
import managerOpen from "../../public/assets/images/manager-open.svg";
import managerReopen from "../../public/assets/images/manager-reopen.svg";
import managerResolve from "../../public/assets/images/manager-resolve.svg";
import managerRespond from "../../public/assets/images/manager-respond.svg";
import circlePlus from "../../public/assets/images/circle_plus.svg";
import circleClip from "../../public/assets/images/circle-clip.svg";
import bonusIcon from "../../public/assets/images/bonusIcon.svg";
import dollarBlack from "../../public/assets/images/dollarBlack.svg";

import ArchiveNoItemicon from "../../ui/Icons/ArchiveNoItemicon";
import FilterNoResultIcon from "../../ui/Icons/FilterNoResultIcon";
import { Fragment } from "react";
import {
  getAbsoluteImageURI,
  getStyledDateTime,
} from "../../lib/functions/utils.lib";
import { Link } from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const notificationLoop = [
  {
    icon: `${msgQcPlus}`,
    iconWidth: 29,
    iconHeight: 28,
    heading: "Admin joined your conversation with QC Agent.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgQc}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Manager sent you a message.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgQc}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "QC Agent sent you a message.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgQc}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Admin sent you a message.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgResolve}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Admin resolved a message that they initiated.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgResolve}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "QC Agent resolved a message that they initiated.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgResolve}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Manager resolved a message that they initiated.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgResolve}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Admin resolved a message that you initiated.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgResolve}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "QC Agent resolved a message that you initiated.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgResolve}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Manager resolved a message that you initiated.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgResolve}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Admin resolved a message initiated by QC Agent.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgResolve}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Admin resolved a message initiated by Manager.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgReopen}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Admin reopened a message resolved by Manager.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgReopen}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Admin reopened a message resolved by QC Agent.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgReopen}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Admin reopened a message you resolved.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgReopen}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Admin reopened a message that they resolved.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgEditor}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Manager responded to your message.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgEditor}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "QC Agent responded to your message.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgEditor}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Admin responded to your message.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgEditor}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "QC Agent responded to a message sent by Admin.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgEditor}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Manager responded to a message sent by Admin.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgEditor}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Admin responded to a message sent by QC Agent.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgEditor}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Admin responded to a message sent by Manager.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgEditor}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Admin responded to a message they sent.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgEditor}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Admin responded to your message.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgEditor}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "QC Agent responded to a message they sent.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${msgEditor}`,
    iconWidth: 26,
    iconHeight: 27,
    heading: "Manager responded to a message they sent.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${Notitipalti}`,
    iconWidth: 26,
    iconHeight: 26,
    heading: "CMG team has granted you Tipalti access.",
    time: "Right now",
    type: "viewmardread",
    id: "",
    tickedId: true,
  },
  {
    icon: `${managerReopen}`,
    iconWidth: 26,
    iconHeight: 24,
    heading: "Admin reopened a support ticket they resolved.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Ticket ID: <span>#SR15</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${managerResolve}`,
    iconWidth: 26,
    iconHeight: 24,
    heading: "Admin resolved a support ticket you opened.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Ticket ID: <span>#SR15</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${managerRespond}`,
    iconWidth: 26,
    iconHeight: 24,
    heading: "Admin responded to your message.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Ticket ID: <span>#SR15</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${managerRespond}`,
    iconWidth: 26,
    iconHeight: 24,
    heading: "Admin responded to a message they sent.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Ticket ID: <span>#SR15</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${circlePlus}`,
    iconWidth: 26,
    iconHeight: 26,
    heading: "Manager has added an original video file.",
    time: "Right now",
    type: "viewmardread",
    id: "#151423",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${circlePlus}`,
    iconWidth: 26,
    iconHeight: 26,
    heading: "QC Agent has added an original video file.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${circlePlus}`,
    iconWidth: 26,
    iconHeight: 26,
    heading: "Admin has added an original video file.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${circleClip}`,
    iconWidth: 26,
    iconHeight: 26,
    heading: "Manager has added a new social media post.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${circleClip}`,
    iconWidth: 26,
    iconHeight: 26,
    heading: "Admin has added a new social media post.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${circleClip}`,
    iconWidth: 26,
    iconHeight: 26,
    heading: "QC Agent has added a new social media post.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${Noticheck}`,
    iconWidth: 26,
    iconHeight: 26,
    heading: "Your video submission has been approved.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${Noticross}`,
    iconWidth: 26,
    iconHeight: 26,
    heading: "Your video submission has been rejected.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${Noticopy}`,
    iconWidth: 26,
    iconHeight: 26,
    heading: "Your video submission has been flagged as a duplicate.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Submission VSID: <span>#151423</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${managerReopen}`,
    iconWidth: 26,
    iconHeight: 26,
    heading: "Admin reopened a support ticket you resolved.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Ticket ID: <span>#SR15</span>
      </>
    ),
    tickedId: false,
  },
  {
    icon: `${bonusIcon}`,
    iconWidth: 32,
    iconHeight: 26,
    heading: "A $35 bonus has been allocated to your account.",
    time: "March 21, 2023 at 11:55 PM UTC",
    type: "archive",
    id: "",
    tickedId: false,
  },
  {
    icon: `${dollarBlack}`,
    iconWidth: 28,
    iconHeight: 23,
    heading:
      "A payment of $7,050 is being processed shortly. Track it on your Tipalti payment history page.",
    time: "2 hours ago",
    type: "viewmardread",
    id: "",
    tickedId: true,
  },
  {
    icon: `${managerRespond}`,
    iconWidth: 26,
    iconHeight: 26,
    heading: "Admin responded to a message they sent.",
    time: "Right now",
    type: "viewmardread",
    id: (
      <>
        Ticket ID: <span>#SR15</span>
      </>
    ),
    tickedId: false,
  },
];

const PartnerNotificationTab = ({
  partnerNotificationsList,
  isLoading,
  updateNotificationSeen,
  updateNotificationArchive,
  updateNotificationReadAll,
  updateNotificationArchiveAll,
  updateNotificationDelete,
  updateNotificationDeleteAll,
  setFilterArchive,
  hasNextPage,
  fetchNextPage,
  search,
  setSearch,
  date,
}) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setFilterArchive(newValue);
  };

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        flexWrap="wrap"
        justifyContent="space-between"
        className={styles.notificationTabsHeader}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="All Notifications" {...a11yProps(0)} />
          <Tab label="Archive" {...a11yProps(1)} />
        </Tabs>
        {value == 0 ? (
          <ButtonGroup>
            <Button
              startIcon={<DoubleCheckIcon />}
              onClick={updateNotificationReadAll}
            >
              Mark all as read
            </Button>
            <Button
              startIcon={<BookmarkIcon />}
              onClick={updateNotificationArchiveAll}
            >
              Archive all
            </Button>
          </ButtonGroup>
        ) : (
          <ButtonGroup>
            <Button
              startIcon={<RemoveIcon />}
              onClick={updateNotificationDeleteAll}
            >
              Remove all
            </Button>
          </ButtonGroup>
        )}
      </Stack>
      <Paper elevation={0} className={styles.tabPanelPaper}>
        <TabPanel value={value} index={0}>
          {/* ====================================== */}
          {/* =========== NO ITEMS START =========== */}
          {/* ====================================== */}

          {/* <Stack className={styles.noItems}>
                        <NotificationNoItemIcon />
                        <Typography variant='body1'>You're all clear - no new notifications</Typography>
                    </Stack> */}

          {/* ====================================== */}
          {/* ============ NO ITEMS END ============ */}
          {/* ====================================== */}
          {isLoading ? (
            ""
          ) : partnerNotificationsList?.[0]?.data?.data?.length ? (
            <PerfectScrollbar
              className={`${styles.notificationBodyScroll} ${styles.newscl}`}
            >
              <List className={styles.notifiactionList}>
                {partnerNotificationsList.map((item, index) => (
                  <Fragment key={index}>
                    {item?.data?.data?.map((itemValue, index) => (
                      <ListItem key={index} className={styles.listStyled}>
                        <Grid
                          container
                          spacing={0}
                          className={styles.overlayBg}
                        >
                          <Grid item md={9}>
                            <Stack
                              direction="row"
                              flexWrap="wrap"
                              className={styles.mediaLeft}
                            >
                              <figure>
                                <img
                                  src={getAbsoluteImageURI(itemValue?.icon)}
                                  width="26"
                                  height="27"
                                  alt="icon"
                                />
                              </figure>
                              <Box className={styles.mediaAddress}>
                                <Typography variant="subtitle1">
                                  {itemValue?.title}
                                </Typography>
                                {/* FILTER NOTIFICATION */}
                                {itemValue?.notification_type_id === 47 ||
                                itemValue?.notification_type_id === 48 ? (
                                  itemValue?.video?.id ? (
                                    <List>
                                      <ListItem>
                                        Submission VSID: #
                                        {itemValue?.video_id
                                          ? itemValue?.video_id
                                          : "N/A"}
                                      </ListItem>
                                    </List>
                                  ) : (
                                    <List>
                                      <ListItem>
                                        Ticked ID: #
                                        {itemValue?.inquiry_id
                                          ? itemValue?.inquiry_id
                                          : "N/A"}
                                      </ListItem>
                                    </List>
                                  )
                                ) : itemValue?.notification_type_id ? (
                                  ""
                                ) : (
                                  ""
                                )}
                                {/* FILTER NOTIFICATION */}

                                <Typography
                                  variant="caption"
                                  className={styles.ticket_timedtls}
                                >
                                  {getStyledDateTime(itemValue?.updated_at)}
                                </Typography>
                              </Box>
                            </Stack>
                          </Grid>
                          <Grid item md={3}>
                            <Stack
                              direction="row"
                              flexWrap="wrap"
                              justifyContent="flex-end"
                              className={`${stylesGap.mediaRight} ${stylesGap.mediaRight_gap}`}
                            >
                              {itemValue?.notification_type_id === 47 ||
                              (itemValue?.notification_type_id === 48) ===
                                true ? (
                                <Link
                                  // to="# /${itemValue?.inquiry_id}"
                                  to={`/member-partner-dashboard/message/video/${itemValue?.inquiry_id}`}
                                >
                                  <Button>View</Button>
                                </Link>
                              ) : (
                                ""
                              )}
                              {itemValue?.seen ? (
                                itemValue?.archive ? (
                                  <Button
                                    onClick={() =>
                                      updateNotificationDelete(itemValue)
                                    }
                                  >
                                    Remove
                                  </Button>
                                ) : (
                                  <Button
                                    onClick={() =>
                                      updateNotificationArchive(itemValue)
                                    }
                                  >
                                    Archive
                                  </Button>
                                )
                              ) : (
                                <Button
                                  onClick={() =>
                                    updateNotificationSeen(itemValue)
                                  }
                                >
                                  Mark as read
                                </Button>
                              )}
                            </Stack>
                          </Grid>
                        </Grid>
                      </ListItem>
                    ))}
                  </Fragment>
                ))}
                {hasNextPage ? (
                  <Box className={styles.viewmoreBtnStyled}>
                    <Button onClick={fetchNextPage}>View more</Button>
                  </Box>
                ) : (
                  ""
                )}
              </List>
            </PerfectScrollbar>
          ) : (
            <Stack className={styles.noItems}>
              <NotificationNoItemIcon />
              <Typography variant="body1">
                You're all clear - no new notifications
              </Typography>
            </Stack>
          )}
        </TabPanel>
        <TabPanel value={value} index={1}>
          {/* ====================================== */}
          {/* =========== NO ITEMS START =========== */}
          {/* ====================================== */}

          {isLoading ? (
            ""
          ) : partnerNotificationsList?.[0]?.data?.data?.length ? (
            <PerfectScrollbar
              className={`${styles.notificationBodyScroll} ${styles.newscl}`}
            >
              <List className={styles.notifiactionList}>
                {partnerNotificationsList.map((item, index) => (
                  <Fragment key={index}>
                    {item?.data?.data?.map((itemValue, index) => (
                      <ListItem key={index} className={styles.listStyled}>
                        <Grid
                          container
                          spacing={0}
                          className={styles.overlayBg}
                        >
                          <Grid item md={9}>
                            <Stack
                              direction="row"
                              flexWrap="wrap"
                              className={styles.mediaLeft}
                            >
                              <figure>
                                <img
                                  src={getAbsoluteImageURI(itemValue?.icon)}
                                  width="26"
                                  height="27"
                                  alt="icon"
                                />
                              </figure>
                              <Box className={styles.mediaAddress}>
                                <Typography variant="subtitle1">
                                  {itemValue?.title}
                                </Typography>
                                {/* FILTER NOTIFICATION */}
                                {itemValue?.notification_type_id === 47 ||
                                itemValue?.notification_type_id === 48 ? (
                                  itemValue?.video?.id ? (
                                    <List>
                                      <ListItem>
                                        Submission VSID: #
                                        {itemValue?.video_id
                                          ? itemValue?.video_id
                                          : "N/A"}
                                      </ListItem>
                                    </List>
                                  ) : (
                                    <List>
                                      <ListItem>
                                        Ticked ID: #
                                        {itemValue?.inquiry_id
                                          ? itemValue?.inquiry_id
                                          : "N/A"}
                                      </ListItem>
                                    </List>
                                  )
                                ) : itemValue?.notification_type_id ? (
                                  ""
                                ) : (
                                  ""
                                )}
                                {/* FILTER NOTIFICATION */}

                                <Typography
                                  variant="caption"
                                  className={styles.ticket_timedtls}
                                >
                                  {getStyledDateTime(itemValue?.updated_at)}
                                </Typography>
                              </Box>
                            </Stack>
                          </Grid>
                          <Grid item md={3}>
                            <Stack
                              direction="row"
                              flexWrap="wrap"
                              justifyContent="flex-end"
                              className={`${stylesGap.mediaRight} ${stylesGap.mediaRight_gap}`}
                            >
                              {itemValue?.notification_type_id === 47 ||
                              (itemValue?.notification_type_id === 48) ===
                                true ? (
                                <Link
                                  // to="#${itemValue?.inquiry_id}"
                                  to={`/member-partner-dashboard/message`}
                                >
                                  <Button>View</Button>
                                </Link>
                              ) : (
                                ""
                              )}
                              {itemValue?.seen ? (
                                itemValue?.archive ? (
                                  <Button
                                    onClick={() =>
                                      updateNotificationDelete(itemValue)
                                    }
                                  >
                                    Remove
                                  </Button>
                                ) : (
                                  <Button
                                    onClick={() =>
                                      updateNotificationArchive(itemValue)
                                    }
                                  >
                                    Archive
                                  </Button>
                                )
                              ) : (
                                <Button
                                  onClick={() =>
                                    updateNotificationSeen(itemValue)
                                  }
                                >
                                  Mark as read
                                </Button>
                              )}
                            </Stack>
                          </Grid>
                        </Grid>
                      </ListItem>
                    ))}
                  </Fragment>
                ))}
                {hasNextPage ? (
                  <Box className={styles.viewmoreBtnStyled}>
                    <Button onClick={fetchNextPage}>View more</Button>
                  </Box>
                ) : (
                  ""
                )}
              </List>
            </PerfectScrollbar>
          ) : (
            <Stack className={`${styles.noItems} ${styles.archivenoItems}`}>
              <ArchiveNoItemicon />
              <Typography variant="body1">
                No archived notifications found.
              </Typography>
            </Stack>
          )}

          {/* ====================================== */}
          {/* ============ NO ITEMS END ============ */}
          {/* ====================================== */}
        </TabPanel>
      </Paper>

      {/* ======================================================= */}
      {/* ============ FILTER RESULT NOT FOUND START ============ */}
      {/* ======================================================= */}

      {/* <Box className={styles.filterNoResult}>
                <FilterNoResultIcon />
                <Typography variant='body1'>We couldn't find any matches for the selected filter(s).</Typography>
                <Button>Reset filters</Button>
            </Box> */}

      {/* ======================================================= */}
      {/* ============= FILTER RESULT NOT FOUND END ============= */}
      {/* ======================================================= */}

      {/* ============================================= */}
      {/* ============ FILTER RESULT START ============ */}
      {/* ============================================= */}

      {/* <Box className={styles.filterResult}>
                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} flexWrap={'wrap'} className={styles.filterResult_header}>
                    <Typography variant='body2'>Filter results for one or more selected filters. <span>1 result</span></Typography>
                    <Button startIcon={<RemoveIcon />}>Remove all</Button>
                </Stack>
                <Box className={styles.filterList}>
                    <PerfectScrollbar className={styles.notificationBodyScroll}>
                        <List className={styles.notifiactionList}>
                            <ListItem className={styles.listStyled}>
                                <Grid container spacing={0} className={styles.overlayBg}>
                                    <Grid item md={9}>
                                        <Stack direction='row' flexWrap='wrap' className={styles.mediaLeft}>
                                            <figure>
                                                <img src={Notiuserbatch} alt='icon' />
                                            </figure>
                                            <Box className={styles.mediaAddress}>
                                                <Typography variant='subtitle1'>QC Agent changed his full name.</Typography>
                                                <List>
                                                    <ListItem>From: full name</ListItem>
                                                    <ListItem>To: full name</ListItem>
                                                </List>
                                                <Typography variant='caption'>Right now</Typography>
                                            </Box>
                                        </Stack>
                                    </Grid>
                                    <Grid item md={3}>
                                        <Stack direction='row' flexWrap='wrap' justifyContent='flex-end' className={styles.mediaRight}>
                                            <Button>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                                                    <path d="M1.13543 0.186912L4.49984 3.55132L7.8504 0.200757C7.96906 0.0744877 8.13402 0.00200757 8.3073 0C8.68963 0 8.99956 0.309927 8.99956 0.692266C9.00282 0.863809 8.93518 1.02912 8.81265 1.14916L5.42747 4.49973L8.81265 7.8849C8.92673 7.9965 8.99368 8.14769 8.99956 8.30719C8.99956 8.68952 8.68963 8.99945 8.3073 8.99945C8.1289 9.00686 7.95563 8.93902 7.82963 8.81254L4.49984 5.44813L1.14235 8.80562C1.02418 8.92766 0.86219 8.99744 0.692378 8.99945C0.310039 8.99945 0.000112197 8.68952 0.000112197 8.30719C-0.00314145 8.13564 0.0644929 7.97033 0.187024 7.85029L3.5722 4.49973L0.187024 1.11455C0.0729385 1.00295 0.00599645 0.851763 0.000112197 0.692266C0.000112197 0.309927 0.310039 0 0.692378 0C0.858798 0.00200757 1.01781 0.0690881 1.13543 0.186912Z" fill="#B8B8B8" />
                                                </svg>
                                            </Button>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </ListItem>

                        </List>
                    </PerfectScrollbar>
                </Box>
            </Box> */}

      {/* ============================================= */}
      {/* ============= FILTER RESULT END ============= */}
      {/* ============================================= */}
    </>
  );
};

export default PartnerNotificationTab;
